import React from 'react';
import { Button } from '@edu-frontend/modules/src/components/ui/Button';
import type { ButtonProps } from '@edu-frontend/modules/src/components/ui/Button';
import cn from 'classnames';

import './hrdsButton.scss';

type hrdsButtonProps = ButtonProps & {
    rounded?: boolean;
};

export const HRDSButton = (props: hrdsButtonProps) => {
    const { className, rounded, ...restProps } = props;

    return <Button {...restProps} className={cn(className, rounded && 'hrds-button_view_rounded')} />;
};
